import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class AlertService {

  constructor(private toastrService: ToastrService) { }

  public success(message: string) {
    this.toastrService.success(message, "Success");
  }
   
  public error(message: string) {
    this.toastrService.error(message, "Error");
  }

  public info(message: string){
      this.toastrService.info(message, "Info");
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/services/alert.service.ts